import axios from "axios";

const endpoint = "https://backend.egy-courses.com/api/";
//const endpoint = "https://localhost:5001/api/";
//const endpoint = "https://trollopy-granuloblastic-tawna.ngrok-free.dev/api/";

// Create axios instance
const apiClient = axios.create({
  baseURL: endpoint,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});

// Token management utilities
export const tokenManager = {
  getToken: () => {
    return localStorage.getItem("jwt_token");
  },

  setToken: (token) => {
    localStorage.setItem("jwt_token", token);
  },

  removeToken: () => {
    localStorage.removeItem("jwt_token");
  },

  isTokenExpired: (token) => {
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp < currentTime;
    } catch (error) {
      return true;
    }
  },
};

// Request interceptor to add JWT token
apiClient.interceptors.request.use(
  (config) => {
    const token = tokenManager.getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle token expiration
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      tokenManager.removeToken();

      const skipRedirect =
        error.config && error.config.meta && error.config.meta.skipAuthRedirect;

      // Redirect to login page unless explicitly skipped
      if (!skipRedirect && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export default apiClient;
